module.exports = __webpack_public_path__ + "static/Dragon_Turtle-9559434e1cc2c06b840d1a2e3b4453f4.jpg";